"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnFilter = void 0;
const react_1 = require("react");
const ramda_1 = require("ramda");
const hooks_1 = require("../../hooks");
const useColumnFilter = (key) => {
    const ls = (0, hooks_1.useLocalStorage)();
    const [columnFilter, setColumnFilter] = (0, react_1.useState)(() => { var _a; return ((_a = ls.getItem(key)) !== null && _a !== void 0 ? _a : {}); });
    const [filterOptions, setFilterOptions] = (0, react_1.useState)(null);
    const updateColumnFilter = (0, react_1.useCallback)((value) => {
        if (filterOptions) {
            const updatedFilter = Object.assign(Object.assign({}, columnFilter), { [filterOptions.id]: value });
            setColumnFilter(updatedFilter);
            ls.setItem(key, updatedFilter);
        }
    }, [columnFilter, key, ls, filterOptions]);
    const getColumnFilterValue = (0, react_1.useCallback)((columnId) => {
        if (columnId) {
            return columnFilter[columnId];
        }
        if (!filterOptions) {
            return undefined;
        }
        return columnFilter[filterOptions.id];
    }, [columnFilter, filterOptions]);
    const openColumnFilter = (0, react_1.useCallback)((id, anchorEl) => setFilterOptions({ id, anchorEl }), []);
    const closeColumnFilter = (0, react_1.useCallback)(() => setFilterOptions(null), []);
    const isColumnFilterActive = (0, react_1.useCallback)((id) => !(0, ramda_1.isNil)(columnFilter[id]), [columnFilter]);
    return {
        anchorEl: filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.anchorEl,
        openColumnFilter,
        updateColumnFilter,
        getColumnFilterValue,
        closeColumnFilter,
        isColumnFilterActive,
    };
};
exports.useColumnFilter = useColumnFilter;
exports.default = exports.useColumnFilter;
